/**
 * IconSubstack Component
 *
 * Custom SVG icon for Substack.
 * Matches Phosphor icon API (size, color props).
 *
 * Based on Substack brand assets / Bootstrap Icons.
 */
export const IconSubstack = ({
  size = 24,
  color = 'currentColor',
  weight = 'regular',
  ...props
}) => {
  const strokeWidth = weight === 'bold' ? 2 : 1.5;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      {/* Substack logo - three horizontal lines with bottom filled */}
      {/* Top line */}
      <line
        x1="4"
        y1="5"
        x2="20"
        y2="5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      {/* Middle line */}
      <line
        x1="4"
        y1="10"
        x2="20"
        y2="10"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      {/* Bottom filled section (the "stack") */}
      <path
        d="M4 15h16v5H4z"
        fill={color}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconSubstack;
